import React from 'react'
import { Megaphone, ShieldCheck, Truck, Tag, Sparkles } from 'lucide-react'

const ANNOUNCEMENTS = [
  { icon: Megaphone, text: 'System maintenance scheduled at 12 AM', color: 'text-gray-400' },
  { icon: ShieldCheck, text: 'New security features active', color: 'text-green-500' },
  { icon: Truck, text: 'Free delivery on orders over ₦50,000', color: 'text-blue-500' },
  { icon: Tag, text: 'Flash sale — Up to 40% off electronics', color: 'text-orange-500' },
  { icon: Sparkles, text: 'New sellers join daily — discover fresh listings', color: 'text-purple-500' },
]

const TopBar = () => {
  return (
    <div className="w-full bg-gray-50 border-b border-gray-100 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap py-1.5">
        {/* Duplicate the list twice for seamless infinite loop */}
        {[...ANNOUNCEMENTS, ...ANNOUNCEMENTS].map((item, i) => (
          <div key={i} className="flex items-center gap-1.5 text-[11px] font-medium text-gray-500 mx-8 shrink-0">
            <item.icon size={12} className={`${item.color} shrink-0`} />
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TopBar
